/**
 * KINETIC — supplements / health pop-up (demo brand).
 * Tubs, pouches, bottles. Loud, high-energy, neon-on-black.
 */
export const brand = {
  name: 'KINETIC',
  industry: 'tech',
  template: 'pop',
  tagline: 'Fuel that earns its colour.',
  drop: { label: 'Summer Cut', endsInHours: 120 },
  // Loud supplement-label identity: condensed heavy display, neon on black.
  theme: {
    display: "'Anton', 'Archivo', sans-serif",
    body: "'Inter', system-ui, sans-serif",
    ink: '#f4f4f4',      // light text
    paper: '#0a0a0b',    // near-black page
    a1: '#39ff14',       // volt green
    a2: '#00ffff',       // cyan
    a3: '#ff1493',       // magenta
  },
  // High energy: heavy bloom, fast parallax, punchy exposure.
  look: {
    exposure: 1.12, envIntensity: 0.75,
    bloomStrength: 0.85, bloomRadius: 0.7, bloomThreshold: 0.5,
    rimLightColor: '#39ff14', rimLightIntensity: 1.6,
    mouseParallax: 0.22, activeScale: 1.22, groundShadow: false,
  },
  hero: {
    eyebrow: 'Drop 03 · Summer Cut',
    headline: 'Fuel,\nin <em>colour.</em>',
    lede: 'Five formulas. Five flavours. A 5-day pop-up. Tubs ship the second the timer ends.',
    cta: 'Grab the drop',
  },
  manifesto: {
    title: 'Loud.\nClean.\nDialed.',
    body: 'No proprietary blends, no filler, third-party tested. Every scoop is labeled to the milligram.',
  },
  // REAL fulfillment: white-label supplements, FDA/GMP, custom labels, Shopify app.
  // Each product maps to a Supliful catalog item — rebrand + sell, no inventory.
  fulfillment: {
    partner: 'Supliful',
    url: 'https://supliful.com',
    model: 'White-label supplements · FDA-reg · GMP · print-on-demand',
    cost: '$49/mo',
    margin: '50–70%',
  },
};

// Each product maps to a real Supliful catalog item (source).
export const products = [
  {
    id: 'preworkout', name: 'IGNITE', tag: 'Pre-Workout · 30 srv', price: '$44',
    source: 'Supliful — Pre-Workout',
    model: '/models/ignite-tub.glb', image: '/renders/ignite-tub.png', keepMaterials: true, modelScale: 2.2,
    shape: 'cylinder', framing: 'square', material: 'plastic',
    colorA: '#39ff14', colorB: '#0a0a0a', accent: '#ff1493', mood: 'pop',
    variants: [
      { sku: 'IGN-LIME', name: 'Lime',  colorA: '#39ff14', colorB: '#0a0a0a', accent: '#ff1493', price: '$44' },
      { sku: 'IGN-BLUE', name: 'Blue Raz', colorA: '#00b3ff', colorB: '#0a0a0a', accent: '#ffaa00', price: '$44' },
      { sku: 'IGN-PINK', name: 'Dragon', colorA: '#ff1493', colorB: '#0a0a0a', accent: '#39ff14', price: '$44' },
    ],
  },
  {
    id: 'greens', name: 'FIELD', tag: 'Super Greens · 30 srv', price: '$39',
    source: 'Supliful — Super Greens Powder',
    model: '/models/field-pouch.glb', image: '/renders/field-pouch.png', keepMaterials: true, modelScale: 2.2,
    shape: 'pouch', framing: 'portrait', material: 'matte',
    colorA: '#1f7a3d', colorB: '#0a0a0a', accent: '#bfff00', mood: 'mint',
  },
  {
    id: 'protein', name: 'BUILD', tag: 'Whey Protein · 2lb', price: '$49',
    source: 'Supliful — Whey / Plant Protein',
    model: '/models/build.glb', image: '/renders/build.png', keepMaterials: true, modelScale: 2.2,
    shape: 'pouch', framing: 'portrait', material: 'matte',
    colorA: '#ffaa00', colorB: '#0a0a0a', accent: '#00ffff', mood: 'sun',
    variants: [
      { sku: 'BLD-VAN',  name: 'Vanilla', colorA: '#ffd98a', colorB: '#0a0a0a', accent: '#00ffff', price: '$49' },
      { sku: 'BLD-CHOC', name: 'Cocoa',   colorA: '#6b3f2a', colorB: '#0a0a0a', accent: '#00ffff', price: '$49' },
    ],
  },
  {
    id: 'electrolyte', name: 'FLOW', tag: 'Hydration Mix · 30 srv', price: '$28',
    source: 'Supliful — Electrolyte / Hydration',
    model: '/models/flow.glb', image: '/renders/flow.png', keepMaterials: true, modelScale: 2.3,
    shape: 'bottle', framing: 'tall', material: 'glass',
    colorA: '#00ffff', colorB: '#0a0a0a', accent: '#ff1493', mood: 'storm',
  },
  {
    id: 'creatine', name: 'CORE', tag: 'Creatine Mono · 60 srv', price: '$32',
    source: 'Supliful — Creatine Monohydrate',
    model: '/models/core.glb', image: '/renders/core.png', keepMaterials: true, modelScale: 2.2,
    shape: 'cylinder', framing: 'square', material: 'chrome',
    colorA: '#c0c0c0', colorB: '#0a0a0a', accent: '#39ff14', mood: 'midnight',
  },
];

export const moodTints = {
  pop: '#0d0d0d', sun: '#1a1206', storm: '#06141a', mint: '#08160d', midnight: '#0a0a14',
};
